export default class KpiModel {
  constructor(kpiData) {
    this.amount = kpiData.amount;
    this.name = kpiData.name;
    this.percentage = kpiData.percentage;
  }
}
